module.exports = __webpack_public_path__ + "img/195.15cab7ac.jpg";